var map = {
	"./_settings.scss": 1396,
	"./base/_alert-boxes.scss": 1397,
	"./base/_badges.scss": 1398,
	"./base/_base.scss": 1399,
	"./base/_cw-footer.scss": 1400,
	"./base/_fonts.scss": 1401,
	"./base/_forms.scss": 1402,
	"./base/_grid.scss": 1403,
	"./base/_layout.scss": 1404,
	"./base/_lightbox.scss": 1405,
	"./base/_modal.scss": 1406,
	"./base/_nav-bar.scss": 1407,
	"./base/_normal_font.scss": 117,
	"./base/_offcanvas.scss": 1408,
	"./base/_pagination.scss": 1409,
	"./base/_panels.scss": 1410,
	"./base/_sharing.scss": 1411,
	"./base/_switches.scss": 1412,
	"./base/_tables.scss": 1413,
	"./base/_tooltips.scss": 1414,
	"./base/_type.scss": 1415,
	"./base/_video.scss": 1416,
	"./base/_visibility.scss": 1417,
	"./base/buttons/_all.scss": 1418,
	"./base/buttons/_mixins.scss": 1419,
	"./base/buttons/_sharing.scss": 1420,
	"./base/forms/_checkboxes.scss": 1421,
	"./base/forms/_input-combos.scss": 1422,
	"./base/forms/_non-text.scss": 1423,
	"./base/forms/_text-fields.scss": 1424,
	"./base/nav-bar/_base-with-links.scss": 1425,
	"./base/nav-bar/_base.scss": 1426,
	"./base/nav-bar/_fade.scss": 1427,
	"./base/nav-bar/_inverted.scss": 1428,
	"./base/nav-bar/_large-up.scss": 1429,
	"./components/cards/_cards.scss": 1430,
	"./components/hero/_hero.scss": 1431,
	"./components/hero/_image_hero.scss": 1432,
	"./components/info/_pillars.scss": 1433,
	"./components/info/_stats.scss": 1434,
	"./components/media-blocks/_content-media-block-left.scss": 1435,
	"./components/story-selector/_story-selector.scss": 1436,
	"./pages/accounts.scss": 1437,
	"./pages/admin.scss": 1438,
	"./pages/admin/grants.scss": 1439,
	"./pages/admin/offline_donations.scss": 1440,
	"./pages/asset_generator.scss": 1441,
	"./pages/authorization.scss": 1442,
	"./pages/birthdays.scss": 1443,
	"./pages/campaigns.scss": 1444,
	"./pages/donations.scss": 1445,
	"./pages/donations/_donate-form.scss": 1446,
	"./pages/donations/_hidden-campaign.scss": 1447,
	"./pages/donations/_sponsor-recognition.scss": 1448,
	"./pages/donations/_thank-you.scss": 1449,
	"./pages/donations/components/_ach-popout-form.scss": 1450,
	"./pages/donations/components/_apple-pay-button.scss": 1451,
	"./pages/donations/components/_browser-fallback.scss": 1452,
	"./pages/donations/components/_donate-buttons.scss": 1453,
	"./pages/donations/components/_donate-by-check-modal.scss": 1454,
	"./pages/donations/components/_donation-form-inputs.scss": 1455,
	"./pages/donations/components/_gift_aid.scss": 1456,
	"./pages/donations/components/_iho.scss": 1457,
	"./pages/donations/components/_offscreen-donate-components.scss": 1458,
	"./pages/donations/components/_stripe-elements.scss": 1459,
	"./pages/donations/dynamic.scss": 1460,
	"./pages/donations/gift-the-spring.scss": 1461,
	"./pages/donations/the-spring-new.scss": 1462,
	"./pages/donations/thespring.scss": 1463,
	"./pages/edit_mailing_list_subscriber.scss": 1464,
	"./pages/exceptions.scss": 1465,
	"./pages/founders.scss": 1466,
	"./pages/mailing-list-subscribers.scss": 1467,
	"./pages/partners.scss": 1468,
	"./pages/premium_impact_profile.scss": 1469,
	"./pages/profile/bps_membership.scss": 1470,
	"./pages/profile/lifetime_impact.scss": 1471,
	"./pages/profile/my_projects.scss": 1472,
	"./pages/profile/shared.scss": 1473,
	"./pages/profile/spring_membership.scss": 1474,
	"./pages/profile/user_private.scss": 1475,
	"./pages/profile/user_public.scss": 1476,
	"./pages/projects/_country_icons.scss": 1477,
	"./pages/projects/projects.scss": 1478,
	"./pages/redeem-the-spring.scss": 1479,
	"./pages/search.scss": 1480,
	"./pages/september-campaign/_modal.scss": 1481,
	"./pages/september_2020.scss": 1482,
	"./pages/static_pages/about.scss": 1483,
	"./pages/static_pages/brand_partnerships.scss": 1484,
	"./pages/static_pages/company_match.scss": 1485,
	"./pages/static_pages/company_match_iframe.scss": 1486,
	"./pages/static_pages/completed_projects.scss": 1487,
	"./pages/static_pages/css_docs.scss": 1488,
	"./pages/static_pages/education.scss": 1489,
	"./pages/static_pages/error.scss": 1490,
	"./pages/static_pages/financials.scss": 1491,
	"./pages/static_pages/fundraise.scss": 1492,
	"./pages/static_pages/gala_dashboard.scss": 1493,
	"./pages/static_pages/home.scss": 1494,
	"./pages/static_pages/hundred_percent_model.scss": 1495,
	"./pages/static_pages/in_kind_donations.scss": 1496,
	"./pages/static_pages/internships.scss": 1497,
	"./pages/static_pages/jobs.scss": 1498,
	"./pages/static_pages/kids.scss": 1499,
	"./pages/static_pages/local_partners.scss": 1500,
	"./pages/static_pages/media.scss": 1501,
	"./pages/static_pages/mission.scss": 1502,
	"./pages/static_pages/our_approach.scss": 1503,
	"./pages/static_pages/our_projects.scss": 1504,
	"./pages/static_pages/our_work.scss": 1505,
	"./pages/static_pages/privacy.scss": 1506,
	"./pages/static_pages/scott_harrison_story.scss": 1507,
	"./pages/static_pages/scotts_story.scss": 1508,
	"./pages/static_pages/sensors.scss": 1509,
	"./pages/static_pages/staff.scss": 1510,
	"./pages/static_pages/the_pool.scss": 1511,
	"./pages/static_pages/volunteer.scss": 1512,
	"./pages/static_pages/water_crisis_learn.scss": 1513,
	"./pages/static_pages/whywater.scss": 1514,
	"./pages/stories.scss": 1515,
	"./pages/subscriptions.scss": 1516,
	"./pages/the_spring_series.scss": 1517,
	"./pages/thirst/thirst.scss": 1518,
	"./pages/uk/about.scss": 1519,
	"./pages/uk/partnerships.scss": 1520,
	"./pages/uk/privacy.scss": 1521,
	"./pages/uk/uk.scss": 1522,
	"./pages/unpledge.scss": 1523,
	"./pages/video_landing_page.scss": 1524,
	"./pages/wwd/community.scss": 1525,
	"./pages/wwd/discover.scss": 1526,
	"./pages/wwd/explore.scss": 1527,
	"./pages/wwd/profile.scss": 1528,
	"./pages/wwd/shared.scss": 1529,
	"./pages/wwd/welcome.scss": 1530,
	"./patterns/action-tiles.scss": 1531,
	"./patterns/avatar-initial.scss": 1532,
	"./patterns/clamp-for-ellipsis.scss": 1533,
	"./patterns/cw-icon-spin.scss": 1534,
	"./patterns/dashed-elements.scss": 1535,
	"./patterns/full-bottom-bg.scss": 1536,
	"./patterns/image-fill.scss": 1537,
	"./patterns/latest-update-indicator.scss": 1538,
	"./patterns/leading-image-block.scss": 1539,
	"./patterns/module.scss": 1540,
	"./patterns/progress.scss": 1541,
	"./patterns/side-by-side.scss": 1542,
	"./patterns/split-bg-block.scss": 1543,
	"./patterns/tabs.scss": 1544,
	"./patterns/text-separator.scss": 1545,
	"./patterns/yellow-underlined.scss": 1546,
	"./react-components/completed-projects-map.scss": 1547,
	"./react-components/email-capture-modal.scss": 1548,
	"./react-components/journey-player.scss": 1549,
	"./react-components/mailing-list-intercept-modal.scss": 1550,
	"./react-components/people-served-input.scss": 1551,
	"./settings/_colors.scss": 1552,
	"./settings/_general.scss": 1553,
	"./settings/_media-queries.scss": 1554,
	"./settings/_mixins.scss": 1555,
	"./settings/_type.scss": 1556,
	"./shared/breadcrumbs.scss": 1557,
	"./shared/clipboard-button.scss": 1558,
	"./shared/comments.scss": 1559,
	"./shared/cookie_banner.scss": 1560,
	"./shared/datepicker.scss": 1561,
	"./shared/fixed-banner.scss": 1562,
	"./shared/geosuggest.scss": 1563,
	"./shared/grecaptcha.scss": 1564,
	"./shared/hide-donate-links.scss": 1565,
	"./shared/intl-tel-input.scss": 1566,
	"./shared/mailing-list-form.scss": 1567,
	"./shared/mailing-list-sign-up-button.scss": 1568,
	"./shared/mobile-donate-banner.scss": 1569,
	"./shared/parsley.scss": 1570,
	"./shared/percy.scss": 1571,
	"./shared/public_campaign_card_details.scss": 1572,
	"./shared/simple-form.scss": 1573,
	"./shared/sly-quiz.scss": 1574,
	"./shared/spring_logo_svg.scss": 1575,
	"./shared/spring_mark_svg.scss": 1576,
	"./shared/spring_series_seasons.scss": 1577,
	"./shared/video-box-container.scss": 1578,
	"./tailwinds.scss": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1395;